import React from 'react';

export interface MetricCardData {
  title: string;
  text: string;
  units?: string;
  icon?: string;
  statusIcon?: string;
}

export interface MetricCardProps {
  cards: MetricCardData[] | MetricCardData;
  style?: 'grey' | 'alert' | 'white';
  className?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ cards, style, className }) => {
  //To handle Array and Single Object
  if (!Array.isArray(cards)) {
    cards = [cards];
  }

  //Edit Styles Here
  if (!style) style = 'grey';
  let color = 'gray-50';
  let borderColor = 'white';

  switch (style) {
    case 'alert':
      color = 'white';
      borderColor = 'red';
      break;
    case 'white':
      color = 'white';
      borderColor = 'gray-50';
      break;
  }

  return (
    <div
      className={`flex grow  bg-${color} border-1 border-${borderColor} rounded divide-x-[0.15rem] divide-white ${className}`}
    >
      {cards.map((card, index) => (
        <div key={index} className={`flex-col p-[0.5rem]    ${!card.icon ? 'text-center' : ''}`}>
          <p className="text-gray-400 text-sm m-0">{card.title}</p>
          <div className={`flex flex-row mt-[0.25rem]  ${!card.icon ? 'justify-center' : ''}`}>
            {card.icon && <img title="image" src={card.icon} className="pe-[0.5rem] w-[2.5rem] h-[2.5rem]" alt="" />}
            <div className="flex flex-col">
              <p className="text-lg leading-[1rem] mb-0">{card.text.toLocaleString()}</p>
              {card.units && (
                <p className="text-xs text-gray-700 opacity-80 leading-[1rem] mb-0 mt-[0.25rem]">{card.units}</p>
              )}
            </div>
            {card.icon && card.statusIcon && (
              <img title="image" src={card.statusIcon} className="px-[0.3rem] w-[1.5rem] h-[1.5rem] self-end" alt="" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCard;
